























/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/ban-ts-ignore */

import {Component, Vue, Watch}                from 'vue-property-decorator';
import {mapActions, mapGetters, mapMutations} from "vuex";
import ol                                     from "openlayers";

@Component({
    computed  : {
        zoom             : {
            get(): number {
                return this.$store.getters.mapZoom;
            },
            set: function (value: number): void {
                this.$store.commit('setZoom', value);
            }
        },
        centerCoordinates: {
            get(): Array<number> {
                return this.$store.getters.mapCenterCoordinates;
            },
            set: function (coordinates: Array<number>): void {
                this.$store.commit('setCenterCoordinates', coordinates);
            }
        },
        ...mapGetters({
            mapExtent: 'mapExtent',
        }),
    },
    methods   : {
        ...mapMutations({
            setZoom             : 'setZoom',
            setCenterCoordinates: 'setCenterCoordinates',
        }),
        ...mapActions({
            focusToFeature: 'focusToFeature',
        }),
    },
    components: {
        ProjectPoints: () => import("@/components/Map/ProjectPoints.vue"),
        BatchGeometry: () => import("@/components/Map/BatchGeometry.vue"),
    },
})
export default class Map extends Vue {
    public selectedFeatures: ol.Feature | ol.render.Feature | null = null;

    mounted() {
        const map: any = this.$refs.map;

        map.$createPromise.then(() => {
            this.$store.commit('setMap', map.$map);
            this.$store.dispatch('loadProjects');
            this.$store.dispatch('loadBatches');
        })
    }

    onMapClick(evt: ol.MapBrowserEvent): void {
        const features = evt.map.getFeaturesAtPixel(evt.pixel);

        if (!features) {
            return;
        }
        const feature = features[0];

        if (feature.getGeometry().getType() === "Polygon") {
            this.selectBatch(feature);
        }

        if (feature.getGeometry().getType() === "Point") {
            this.selectProject(feature);
        }
    }

    selectBatch(feature: ol.Feature | ol.render.Feature | any): void {
        this.selectedFeatures = feature;

        // todo: not working multiple params
        // this.$store.dispatch('selectBatch', {
        //     batchId,
        //     projectId
        // });
        this.$store.dispatch('selectBatch', feature.getId());

        this.$store.dispatch('loadProjectData', feature.getProperties().projectId).then(() => {
            this.$store.commit('setSelectedProjectUuid', feature.getProperties().projectId);
        });
    }

    selectProject(feature: ol.Feature | ol.render.Feature | any): void {
        this.$store.dispatch('focusToFeature', feature);
        this.$store.dispatch('selectProject', feature.getId());
    }

    @Watch('centerCoordinates')
    onCenterCoordinatesChange() {
        this.$store.dispatch('calculateExtent');
    }
}
